var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 567.2 94.5",
    style: {
      enableBackground: "new 0 0 567.2 94.5"
    },
    xmlSpace: "preserve",
    color: "#2AEE7D",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.3,38.8l0-4.2c-2,3-5.7,4.7-9.9,4.7c-4.9,0-9.1-1.7-12.5-5.1c-3.5-3.4-5.1-8.3-5.1-14.5 c0-6.2,1.8-11,5.3-14.5C9.6,1.8,13.9,0.1,19,0.1c8.3,0,13.9,4.8,15.9,12.1l-6.5,1.7c-2-4.8-5.1-7.2-9.4-7.2c-6.5,0-11,4.5-11,13 c0,8.8,4.4,13,10.8,13c5.2,0,8.1-3.3,8.6-7.3h-7.1v-5.9h14v19.3H28.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.8,15.7c3,0,4.5-1.4,4.5-4.3c0-2.9-1.5-4.3-4.5-4.3h-6.9v8.7H61.8z M66.2,21.7l10.6,17.1h-7.9L58.6,22.3 h-3.7v16.5h-7.1V0.5h14c7.4,0,11.7,4.3,11.7,10.9C73.4,16.5,70.8,20.3,66.2,21.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.6,9.9l-4.1,13.3h8.1L100.6,9.9z M109.5,38.8l-2.8-9H94.5l-2.8,9h-7.7L97,0.5h7.1l13,38.3H109.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.2,13.3c-1.7-4.4-4.8-6.7-9.5-6.7c-3.1,0-5.7,1.1-7.8,3.3c-2,2.2-3.1,5.5-3.1,9.7s1,7.4,3.1,9.7 c2.1,2.2,4.7,3.3,7.8,3.3c4.7,0,7.8-2.2,9.5-6.7l6.4,1.6c-1.8,7.4-7.6,11.6-15.9,11.6c-5.1,0-9.4-1.8-12.9-5.2 c-3.5-3.4-5.3-8.3-5.3-14.4c0-6.1,1.8-11,5.3-14.4c3.5-3.4,7.8-5.2,12.9-5.2c8.3,0,14.1,4.2,15.9,11.6L151.2,13.3z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "169.4,38.8 169.4,0.5 176.5,0.5 176.5,15.1 191.8,15.1 191.8,0.5 198.9,0.5 198.9,38.8 191.8,38.8  191.8,21.7 176.5,21.7 176.5,38.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "210.5,7.1 210.5,0.5 238.9,0.5 238.9,7.1 228.3,7.1 228.3,38.8 221.1,38.8 221.1,7.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "250.5,0.5 274.2,0.5 274.2,7.1 257.6,7.1 257.6,15.1 270.9,15.1 270.9,21.7 257.6,21.7 257.6,32.3  274.7,32.3 274.7,38.8 250.5,38.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "308.9,0.5 316,0.5 316,38.8 308.5,38.8 294.4,13.6 294.4,38.8 287.3,38.8 287.3,0.5 294.8,0.5  308.9,25.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "330.5,38.8 330.5,0.5 338.5,0.5 347.6,24.5 356.6,0.5 364.6,0.5 364.6,38.8 357.5,38.8 357.5,15.2  350.1,35.3 345,35.3 337.7,15.2 337.7,38.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M406,0.5v23.8c0,9.9-5.5,15-14.3,15c-8.8,0-14.3-5.1-14.3-15V0.5h7.1v23.9c0,5.5,2.4,8.3,7.2,8.3 c4.8,0,7.2-2.8,7.2-8.3V0.5H406z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434.5,10.7c-1.4-2.7-3.2-4.1-5.3-4.1c-2.1,0-3.7,1.5-3.7,3.5c0,2.4,2.6,4.2,5.7,5.7 c4.6,2,10.7,4.9,10.6,11.5c0,7.4-4.8,11.9-12.3,11.9c-3.3,0-6.2-1-8.7-3.1c-2.4-2.1-3.9-4.7-4.5-7.7l5.7-3.6 c1.5,5.2,4,7.8,7.6,7.8c3.3,0,5-1.6,5-5c0-2.2-2.5-4-5.7-5.4c-4.5-1.9-10.5-4.8-10.3-11.9c0-2.9,1-5.4,3-7.4c2-2,4.5-3,7.5-3 c5.2,0,8.9,2.3,11.1,7L434.5,10.7z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "453.6,0.5 477.3,0.5 477.3,7.1 460.7,7.1 460.7,15.1 474,15.1 474,21.7 460.7,21.7 460.7,32.3  477.9,32.3 477.9,38.8 453.6,38.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M517.9,0.5v23.8c0,9.9-5.5,15-14.3,15s-14.3-5.1-14.3-15V0.5h7.1v23.9c0,5.5,2.4,8.3,7.2,8.3 c4.8,0,7.2-2.8,7.2-8.3V0.5H517.9z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "531.2,38.8 531.2,0.5 539.2,0.5 548.2,24.5 557.3,0.5 565.3,0.5 565.3,38.8 558.1,38.8 558.1,15.2  550.8,35.3 545.6,35.3 538.3,15.2 538.3,38.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,80.3l1.8,6H6.2L8,80.3z M6.4,76.1L0.5,93.4H4l1.3-4.1h5.5l1.3,4.1h3.5L9.6,76.1H6.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50,76.1 45.9,86.9 41.8,76.1 38.2,76.1 38.2,93.4 41.4,93.4 41.4,82.7 44.7,91.9 47.1,91.9 50.4,82.7  50.4,93.4 53.6,93.4 53.6,76.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.1,80.7c-0.6-1.2-1.4-1.8-2.4-1.8c-1,0-1.7,0.7-1.7,1.6c0,1.1,1.2,1.9,2.6,2.6c2.1,0.9,4.8,2.2,4.8,5.2 c0,3.4-2.2,5.4-5.6,5.4c-1.5,0-2.8-0.5-3.9-1.4c-1.1-0.9-1.8-2.1-2.1-3.5l2.6-1.6c0.7,2.4,1.8,3.5,3.4,3.5c1.5,0,2.3-0.7,2.3-2.3 c0-1-1.1-1.8-2.6-2.4c-2.1-0.9-4.7-2.2-4.7-5.4c0-1.3,0.4-2.4,1.3-3.3c0.9-0.9,2-1.4,3.4-1.4c2.4,0,4,1,5,3.1L87.1,80.7z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "114,76.1 114,79.1 118.8,79.1 118.8,93.4 122,93.4 122,79.1 126.8,79.1 126.8,76.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "151.9,76.1 151.9,93.4 162.9,93.4 162.9,90.5 155.1,90.5 155.1,85.7 161.2,85.7 161.2,82.7  155.1,82.7 155.1,79.1 162.6,79.1 162.6,76.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.5,83c1.4,0,2-0.6,2-2c0-1.3-0.7-2-2-2h-3.1V83H194.5z M196.5,85.7l4.8,7.8h-3.6l-4.7-7.5h-1.7v7.5h-3.2 V76.1h6.3c3.4,0,5.3,2,5.3,4.9C199.8,83.3,198.6,85.1,196.5,85.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.1,90.5h1.2c1.5,0,2.8-0.3,3.9-1.1c1.2-0.8,1.9-2.4,1.9-4.6c0-2.2-0.7-3.8-1.9-4.6 c-1.2-0.8-2.4-1.1-3.9-1.1h-1.2V90.5z M225.9,93.4V76.1h5.4c4.1,0,8.1,2.6,8.1,8.7c0,6-4,8.7-8.1,8.7H225.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.1,80.3l1.8,6h-3.7L270.1,80.3z M268.5,76.1l-5.9,17.4h3.5l1.3-4.1h5.5l1.3,4.1h3.5l-5.9-17.4H268.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "311.1,76.1 307,86.9 302.9,76.1 299.3,76.1 299.3,93.4 302.5,93.4 302.5,82.7 305.8,91.9 308.2,91.9  311.5,82.7 311.5,93.4 314.7,93.4 314.7,76.1  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.99de7a538b2d217044e97a7bfc702da6.svg";
export { ForwardRef as ReactComponent };